import React from "react";
import Hero from "@/components/Common/Hero";
import FAQ from "@/components/Common/FAQ";
import FreeAppraisal from "@/components/Common/FreeAppraisal";
import { createClient } from "../../../../../prismicio";
import { SliceZone } from "@prismicio/react";
import Metadata from "@/components/Metadata";
import Layout from "@/components/Layout";
import Breadcrumbs from "@/components/Common/Breadcrumbs";
import FeatureDetails from "@/components/FeaturesDetailsSection/FeatureDetails";
import FeatureDetailsSlice from "@/components/FeaturesDetails/FeatureDetails";
import HowItWorks from "@/components/Common/HowItWorks";

const SellPlatinumRingPage = ({ page, globals }) => {
  const pageData = page?.data;
  const commonComponents = globals?.data;

  const components = {
    faqs: FAQ,
  };

  const whyChooseUs = {
    features_details: FeatureDetailsSlice,
  };

  const whatWeBuy = {
    features_details: FeatureDetailsSlice,
  };

  const bestTime = {
    features_details: FeatureDetailsSlice,
  };
  return (
    <Layout data={commonComponents}>
      <Metadata
        title={pageData?.metadata_title}
        description={pageData?.metadata_desc}
        image={pageData?.metadata_image?.url}
        path="/what-we-buy/sell-diamonds-nyc"
      />
      <Hero
        caption={pageData?.hero_caption || ""}
        title={pageData?.hero_title || ""}
        sideImage={pageData?.hero_side_image.url || ""}
        sideImageMobile={pageData?.hero_mobile_side_image.url || ""}
        backgroundImage={pageData?.hero_background_image}
        description={pageData?.hero_description || ""}
        features={pageData?.hero_feature_list || []}
        page={"Sell Diamonds"}
        visibility={true}
        viewMoreLink="/what-we-buy/watch-buyers-nyc"
      />
      <Breadcrumbs />
      <SliceZone slices={page?.data?.slices1} components={whyChooseUs} />
      <SliceZone slices={page?.data?.slices3} components={whatWeBuy} />
      <HowItWorks data={pageData} />
      <FeatureDetails data={pageData} />
      <SliceZone slices={page?.data?.slices4} components={bestTime} />
      <SliceZone slices={page?.data?.slices2} components={components} />
      <FreeAppraisal whiteBg={true} data={pageData} page={"Sell Diamonds"} />
    </Layout>
  );
};

export default SellPlatinumRingPage;

export async function getStaticProps({ previewData }) {
  const client = createClient({ previewData });

  const page = await client.getSingle("sell_platinum_ring");
  const globals = await client.getSingle("globals");

  return {
    props: {
      page,
      globals,
    },
  };
}
